module.exports = __webpack_public_path__ + "static/media/bind.b4fce5f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/bind.mp4
// module id = 9P0e
// module chunks = 0